export const SUPPORTED_EXTENSIONS = ".pdf, .doc, .docx";